/**
 * Digital Marketing page: card sliders (drive results, why choose, toolkit)
 * and the hover-to-expand services list. Slick is enqueued by template-digital-marketing.php.
 */
jQuery(function ($) {
    if ($.fn.slick) {
        $('.dm-cards-slider').not('.slick-initialized').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>',
            responsive: [
                { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                { breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 } }
            ]
        });
    }

    $('.dm-service-row a').on('click', function (e) {
        e.stopPropagation();
    });

    $('.dm-service-row').on('mouseenter click', function (e) {
        if (e.type === 'click' && window.innerWidth <= 767 && $(this).hasClass('active')) {
            $(this).removeClass('active');
            return;
        }
        if ($(this).hasClass('active')) return;
        $('.dm-service-row').removeClass('active');
        $(this).addClass('active');
    });
});
